import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { ADD_FIM_NOTES_SUCCESS, ADD_FIM_NOTES_FAILURE } from '../actions';

export default function* addFimNotesSaga(action) {
    const baseSiteID = localStorage.getItem('baseSiteId');
    const { sapOrderNumber, setNumber, sapLineNumber, notes } = action.payload;
    const encodedNotes = encodeURIComponent(notes || '');
    const url = `/occ/v2/${baseSiteID}/dashboard/save/Notes?sapOrderNumber=${sapOrderNumber}&setNumber=${setNumber}&sapLineNumber=${sapLineNumber}&notes=${encodedNotes}`;
    try {
        const result = yield axios.post(url).then((response) => response.data);
        
        yield put({ 
            type: ADD_FIM_NOTES_SUCCESS, 
            payload: {
                ...action.payload,
                ...result
            }
        });
    } 
    catch (error) {
        logUiErrorToBackend(error, {
            apiEndPoint: url,
            requestPayload: action.payload || {}
        });
        
        yield put({
            type: ADD_FIM_NOTES_FAILURE,
            payload: {
                error: errorHandler('503'),
            }
        });
    }
}